var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupOfFourIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    filter: "url(#filter0_d_1285_620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_Meeting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.7926 15.0319V50.1881C63.7926 56.384 58.7697 61.4069 52.5738 61.4069H17.4258C11.2299 61.4069 6.20703 56.384 6.20703 50.1881V15.0319C6.20703 8.83597 11.2299 3.81311 17.4258 3.81311H52.5739C58.7698 3.81311 63.7926 8.83597 63.7926 15.0319Z",
    fill: "white",
    stroke: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.7891 27.65H46.1211V24.8668C46.1211 22.2242 43.9648 20.068 41.3223 20.068C38.6738 20.068 36.5234 22.2242 36.5234 24.8668V27.65H33.4766V24.8668C33.4766 22.2242 31.3262 20.068 28.6777 20.068C26.0352 20.068 23.8789 22.2242 23.8789 24.8668V27.65H20.2109C18.5176 27.65 17.1406 29.0328 17.1406 30.7262V45.1344C17.1406 46.8278 18.5176 48.2047 20.2109 48.2047H23.8848C23.873 48.6383 23.8848 50.1852 23.8789 51.7262C23.8789 52.0485 24.1426 52.3121 24.4648 52.3121H32.8906C33.2187 52.3121 33.4766 52.0485 33.4766 51.7262C33.4766 50.1676 33.4883 48.65 33.4707 48.2047H36.5293C36.5176 48.6383 36.5234 50.1852 36.5234 51.7262C36.5234 52.0485 36.7812 52.3121 37.1094 52.3121H45.5352C45.8574 52.3121 46.1211 52.0485 46.1211 51.7262C46.1152 50.1676 46.1269 48.65 46.1094 48.2047H49.7891C51.4824 48.2047 52.8594 46.8278 52.8594 45.1344V30.7262C52.8594 29.0328 51.4824 27.65 49.7891 27.65ZM51.6875 45.1344C51.6875 46.1832 50.8379 47.0328 49.7891 47.0328H45.9336C45.3535 45.0289 43.5078 43.5524 41.3223 43.5524C39.1309 43.5524 37.2852 45.0289 36.7109 47.0328H33.2891C32.7148 45.0289 30.8691 43.5524 28.6777 43.5524C26.4922 43.5524 24.6465 45.0289 24.0664 47.0328H20.2109C19.1621 47.0328 18.3125 46.1832 18.3125 45.1344V30.7262C18.3125 29.6774 19.1621 28.8219 20.2109 28.8219H49.7891C50.8379 28.8219 51.6875 29.6774 51.6875 30.7262V45.1344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.6777 12.9078C26.9609 12.9078 25.5664 14.3024 25.5664 16.0192C25.5664 17.736 26.9609 19.1364 28.6777 19.1364C30.3945 19.1364 31.7949 17.736 31.7949 16.0192C31.7949 14.3024 30.3945 12.9078 28.6777 12.9078ZM28.6777 17.9645C27.6113 17.9645 26.7383 17.0914 26.7383 16.0192C26.7383 14.9469 27.6113 14.0797 28.6777 14.0797C29.75 14.0797 30.623 14.9469 30.623 16.0192C30.623 17.0914 29.75 17.9645 28.6777 17.9645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.3223 12.9078C39.6055 12.9078 38.2051 14.3024 38.2051 16.0192C38.2051 17.736 39.6055 19.1364 41.3223 19.1364C43.0391 19.1364 44.4336 17.736 44.4336 16.0192C44.4336 14.3024 43.0391 12.9078 41.3223 12.9078ZM41.3223 17.9645C40.25 17.9645 39.377 17.0914 39.377 16.0192C39.377 14.9469 40.25 14.0797 41.3223 14.0797C42.3887 14.0797 43.2617 14.9469 43.2617 16.0192C43.2617 17.0914 42.3887 17.9645 41.3223 17.9645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.6777 36.3922C26.9609 36.3922 25.5664 37.7867 25.5664 39.5035C25.5664 41.2203 26.9609 42.6207 28.6777 42.6207C30.3945 42.6207 31.7949 41.2203 31.7949 39.5035C31.7949 37.7867 30.3945 36.3922 28.6777 36.3922ZM28.6777 41.4489C27.6113 41.4489 26.7383 40.5758 26.7383 39.5035C26.7383 38.4371 27.6113 37.5641 28.6777 37.5641C29.75 37.5641 30.623 38.4371 30.623 39.5035C30.623 40.5758 29.75 41.4489 28.6777 41.4489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.3223 36.3922C39.6055 36.3922 38.2051 37.7867 38.2051 39.5035C38.2051 41.2203 39.6055 42.6207 41.3223 42.6207C43.0391 42.6207 44.4336 41.2203 44.4336 39.5035C44.4336 37.7867 43.0391 36.3922 41.3223 36.3922ZM41.3223 41.4489C40.25 41.4489 39.377 40.5758 39.377 39.5035C39.377 38.4371 40.25 37.5641 41.3223 37.5641C42.3887 37.5641 43.2617 38.4371 43.2617 39.5035C43.2617 40.5758 42.3887 41.4489 41.3223 41.4489Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1285_620",
    x: 0.0999999,
    y: -0.290015,
    width: 73.8,
    height: 73.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1285_620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1285_620",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOfFourIcon);
export default __webpack_public_path__ + "static/media/group-of-four-icon.d2a994055d81560c94dbd6fb4501d979.svg";
export { ForwardRef as ReactComponent };